import ChartContainer from "./ChartContainer";
import React, {useEffect, useState} from "react";
import DownloadButton from "components/buttons/DownloadButton";
import HighchartsReact from "highcharts-react-official";
import {useSelector} from "react-redux";
import {selectOptions} from "../../../redux/features/optionsSlice";
import AnnualBarChart from "../HighCharts/AnnualBarChart";
import {euro} from "../../../utils/formatters";
import {useLazyGetNetPremiumOurShareSumChartQuery} from "../../../redux/api/chartsApiSlice";
import {SeriesOptionsType} from "highcharts";
import {selectUser} from "../../../redux/features/userSlice";

export default function NetPremiumOurShareSumChart(props: {
  chartRef: React.RefObject<HighchartsReact.RefObject>,
  className: string,
  year: number
}) {

  const title = 'Somma di net premium our share'
  const states = useSelector(selectOptions).states
  const [getData, {isLoading, isFetching, isError, data}] = useLazyGetNetPremiumOurShareSumChartQuery()
  const description = 'Il grafico mostra la distribuzione della sommatoria dei premi delle trattative per mese nei diversi stati.'

  const budgetGroup = useSelector(selectUser).preferences?.charts_params?.budget_group
  const uwYear = useSelector(selectUser).preferences?.charts_params?.uw_year
  const isia = useSelector(selectUser).preferences?.charts_params?.isia

  useEffect(() => {
    if (budgetGroup && typeof uwYear === 'number' && isia) {
      getData({
        uw_year: uwYear,
        budget_group: budgetGroup.value,
        isia: isia.value,
        year: props.year
      })
    }
  }, [budgetGroup, getData, isia, props.year, uwYear])


  return <ChartContainer
      description={description}
      loading={isLoading || isFetching}
      className={props.className}
      title={title}
      buttons={[<DownloadButton key={'download-button'} chartRef={props.chartRef}/>]}>
    <AnnualBarChart
        chartRef={props.chartRef}
        options={{
          exporting: {
            chartOptions: {
              title: {
                text: title
              },
              subtitle: {
                text: `Parametri: UW Year ${uwYear} - ${budgetGroup?.label} - ${isia?.label}`
              }
            }
          },
          yAxis: {
            labels: {
              format: '{text} €'
            },
            title: {
              text: ''
            }
          },
          tooltip: {
            pointFormatter: function () {
              const value = euro(this.y ? this.y : 0)
              const name = this.name ? this.name : ''
              const symbol = this.color ? `<span style='color: ${this.color}'>●</span>` : ''
              return `${symbol} ${name} <span style='font-weight: bolder'>${value}</span>`
            },
            useHTML: true
          },
          series: data ? data.map(el => ({
            name: states.find(state => state.value === el.state)?.text,
            type: 'bar',
            data: el.premiums,
            color: states.find(state => state.value === el.state)?.color,
          })) : []

        }}
    />
  </ChartContainer>
}